import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, obj=authed, false=guest/unauthed

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password, remember = true) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    if (!data.requires_2fa) setUser(data);
    return data;
  };

  const verifyTwoFactor = async (mfaToken, code, remember = true) => {
    const { data } = await api.post("/auth/2fa/verify", { mfa_token: mfaToken, code, remember });
    setUser(data);
    return data;
  };

  const register = async (email, password, name, isMinor = false) => {
    const { data } = await api.post("/auth/register", { email, password, name, is_minor: isMinor });
    setUser(data);
    return data;
  };

  const guestLogin = async (name) => {
    const { data } = await api.post("/auth/guest", { name });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, guestLogin, logout, checkAuth, verifyTwoFactor, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
